import { Clipboard, ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { Project } from 'lfx-pcc';
import { TreeNode } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'lfx-ical-modal',
  standalone: true,
  imports: [CommonModule, InputTextModule, ButtonModule, ClipboardModule],
  templateUrl: './ical-modal.component.html',
  styleUrl: './ical-modal.component.scss',
  providers: [Clipboard],
})
export class ICalModalComponent {
  public copyLabel: string = 'Copy';
  public iCalLink: string = '';
  public iCalSubprojectLink: string = '';
  public project: Project | undefined;

  private dialogConfig: DynamicDialogConfig<{ project: TreeNode<Project> }> = inject(DynamicDialogConfig);

  public constructor() {
    this.iCalLink = `https://webcal.${environment.environment}.itx.linuxfoundation.org/lfx/${this.dialogConfig.data?.project.data?.ID}`;
    this.iCalSubprojectLink = `https://webcal.${environment.environment}.itx.linuxfoundation.org/lfx/${this.dialogConfig.data?.project.data?.ID}_sub`;
    this.project = this.dialogConfig.data?.project.data;
  }

  public onCopy(): void {
    this.copyLabel = 'Copied!';
    setTimeout(() => {
      this.copyLabel = 'Copy';
    }, 3000);
  }
}
